module.exports = __webpack_public_path__ + "static/img/2-1-4.98704099.jpg";